export default "__VITE_ASSET__KeeDyIRX__"